"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _ = require("../..");
var _utils = require("../../utils");
var _InputMessage = _interopRequireDefault(require("../InputMessage"));
var S = _interopRequireWildcard(require("./TextField.style"));
var _excluded = ["className", "error", "errorMessage", "helpText", "id", "label", "icon", "success"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var IconSuccess = function IconSuccess(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", props, /*#__PURE__*/_react["default"].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12zm0-1.6C6.256 22.4 1.6 17.744 1.6 12 1.6 6.256 6.256 1.6 12 1.6c5.744 0 10.4 4.656 10.4 10.4 0 5.744-4.656 10.4-10.4 10.4zM6.634 11.434a.8.8 0 0 1 1.132 0L10.4 14.07l5.834-5.835a.8.8 0 0 1 1.132 1.132l-6.344 6.343a.88.88 0 0 1-1.244 0l-3.144-3.143a.8.8 0 0 1 0-1.132z"
  }));
};
IconSuccess.defaultProps = {
  fill: "currentColor",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};
var IconError = function IconError(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", props, /*#__PURE__*/_react["default"].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26 14c0 6.627-5.373 12-12 12S2 20.627 2 14 7.373 2 14 2s12 5.373 12 12zm-1.6 0c0-5.744-4.656-10.4-10.4-10.4C8.256 3.6 3.6 8.256 3.6 14c0 5.744 4.656 10.4 10.4 10.4 5.744 0 10.4-4.656 10.4-10.4zm-11.2 6.2v-1.4a.8.8 0 0 1 1.6 0v1.4a.8.8 0 0 1-1.6 0zm0-4V7.8a.8.8 0 0 1 1.6 0v8.4a.8.8 0 0 1-1.6 0z"
  }));
};
IconError.defaultProps = {
  fill: "currentColor",
  width: "28",
  height: "28",
  viewBox: "0 0 28 28",
  xmlns: "http://www.w3.org/2000/svg"
};
var TextField = function TextField(_ref) {
  var className = _ref.className,
    error = _ref.error,
    errorMessage = _ref.errorMessage,
    helpText = _ref.helpText,
    _ref$id = _ref.id,
    id = _ref$id === void 0 ? (0, _utils.createID)() : _ref$id,
    label = _ref.label,
    icon = _ref.icon,
    success = _ref.success,
    props = _objectWithoutProperties(_ref, _excluded);
  var shouldDisplayHelpText = helpText && !errorMessage;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: className
  }, label && /*#__PURE__*/_react["default"].createElement(S.Label, {
    htmlFor: id,
    error: error
  }, label, success && /*#__PURE__*/_react["default"].createElement(IconSuccess, null)), /*#__PURE__*/_react["default"].createElement(_.Input, _extends({
    id: id,
    icon: icon,
    error: error
  }, props)), shouldDisplayHelpText && /*#__PURE__*/_react["default"].createElement(_InputMessage["default"], {
    color: "text-light"
  }, helpText), errorMessage && /*#__PURE__*/_react["default"].createElement(_InputMessage["default"], {
    color: "error"
  }, /*#__PURE__*/_react["default"].createElement(IconError, null), " ", errorMessage));
};
TextField.propTypes = {
  className: _propTypes["default"].string,
  /**
   * If `true`, the input will be displayed in an error state.
   */
  error: _propTypes["default"].bool,
  errorMessage: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].bool]),
  id: _propTypes["default"].string,
  label: _propTypes["default"].string,
  /**
   * The icon element.
   */
  icon: _propTypes["default"].func,
  helpText: _propTypes["default"].string,
  success: _propTypes["default"].bool
};
var _default = exports["default"] = TextField;